import React from "react";

const ContextStateNavBar = React.createContext();

export const ProviderStateButton = ContextStateNavBar.Provider;

export default ContextStateNavBar;